import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { MainButton } from '../Button/MainButton'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start',
		padding: '16px 0px 6px 0px'
	}
}))

const DeleteConfirmation = (props) => {
	const classes = useStyles()

	let {
		isShown,
		setIsShown,
		onConfirmDelete,
		title = 'Delete',
		body = 'Are you sure?',
		isDeleteLoading,
		confirmButtonText
	} = props

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => {
				if (!isDeleteLoading) setIsShown(false)
			}}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle>
				<Typography
					style={{
						fontFamily: 'Nunito',
						color: '#1A1A35',
						fontSize: '16px',
						lineHeight: '22px',
						textTransform: 'uppercase',
						fontWeight: '800',
						marginBottom: 16
					}}>
					{title}
				</Typography>
			</DialogTitle>
			<DialogContent style={{ paddingTop: 0 }}>
				<Typography
					variant="body2"
					style={{
						fontFamily: 'Nunito',
						color: '#1A1A35',
						fontSize: '16px',
						lineHeight: '22px',
						fontWeight: '600'
						// marginTop: 16
					}}>
					{body}
				</Typography>
				{props.children}
				<DialogActions className={classes.dialogActions}>
					<MainButton
						variant="contained"
						label={confirmButtonText || 'DELETE'}
						backgroundColor="#EB4C4C"
						onClick={onConfirmDelete}
						disabled={isDeleteLoading}
						style={{ height: 40 }}
					/>
					<MainButton
						variant="outlined"
						label="CANCEL"
						onClick={() => setIsShown(false)}
						disabled={isDeleteLoading}
						style={{ height: 40 }}
					/>
				</DialogActions>
			</DialogContent>
		</Dialog>
	)
}

export default DeleteConfirmation
